import { FilterValues } from '../models';
import { DEFAULT_FREQUENCIES } from './Frequency';

export const INITIAL_FILTER_VALUES: FilterValues = {
    frequencies: DEFAULT_FREQUENCIES,
    voltages: [],
    efficiencyClasses: [],
    speeds: [],
    ratedPowerBasedOns: [],
    powers: [],
    frameMaterials: [],
    motorTypes: [],
    frameSizes: [],
    mlfbs: [],
    explosionProtections: []
};

